import { Mediator, app } from "modular-openscriptjs";
import { inform, eParse } from "../../helpers";
import { STRINGS, api } from "../../declarations";
import { analyze } from "../../analytics";

const broker = app("broker");
const $e = app("$e");

export default class OfflineMpesaPayment extends Mediator {
	constructor() {
		super();

		let event = {
			payment: {
				method: {
					offlineMpesa: {
						process: true,
					},
				},
			},
		};

		broker.registerEvents(event);
	}

	$$payment = {
		method: {
			offlineMpesa: {
				process: (ed, event) => this.processPayment(ed, event),
			},
		},
	};

	async processPayment(ed, event) {
		let { meta, message } = eParse(ed);

		this.broadcast($e.capa.needs.balance);

		let amount = message.get("amount", null);

		let res = await api.post(`${meta.get("route")}`, {
			method: message.method,
			information: message.paymentData,
			amount,
		});

		if (!res) {
			return this.broadcast($e.payment.has.processingError, ed);
		}

		inform(res.message, STRINGS.SUCCESS);

		analyze("payment_made", {
			amount,
			currency: window.userCurrency,
			method: "offline_mpesa",
		});

		return this.broadcast($e.payment.completed, ed);
	}
}